export const SOCIAL_ITEMS_DATA = [
  {
    icon: "/social-items/website.svg",
    text: "Website",
    active: false,
    type: "website",
  },
  {
    icon: "/social-items/facebook.svg",
    text: "Facebook",
    active: false,
    type: "facebook",
  },
  {
    icon: "/social-items/twitter.svg",
    text: "Twitter",
    active: false,
    type: "twitter",
  },
  {
    icon: "/social-items/instagram.svg",
    text: "Instagram",
    active: false,
    type: "instagram",
  },
  {
    icon: "/social-items/linkedin.svg",
    text: "Linkedin",
    active: false,
    type: "linkedin",
  },
  {
    icon: "/social-items/youtube.svg",
    text: "Youtube",
    active: false,
    type: "youtube",
  },
  {
    icon: "/social-items/wp.svg",
    text: "Whatsapp",
    active: false,
    type: "whatsapp",
  },
  {
    icon: "/social-items/tg.svg",
    text: "Telegram",
    active: false,
    type: "telegram",
  },
  {
    icon: "/social-items/snap.svg",
    text: "Snapchat",
    active: false,
    type: "snapchat",
  },
  {
    icon: "/social-items/tiktok.svg",
    text: "Tiktok",
    active: false,
    type: "tiktok",
  },
];
